import { useEffect, useState } from 'react';
import { fetchDataFromApi } from './api';

const useFetchData = (url: string) => {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        if (!url) return null;
        setLoading(true);
        setError(null);
        try {
            const result = await fetchDataFromApi(url);
            setData(result);
        } catch (error) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [url]);

    return { data, loading, error, refetch: fetchData };
};


export default useFetchData;
